import classnames from 'classnames';
import React, { ComponentType, ReactElement } from 'react';
import { Link } from 'react-router-dom';

export interface NavigationTab {
  component: ComponentType;
  pathname: string;
  label: string;
}

export interface NavigationTabsProps {
  tabs: NavigationTab[];
}

export function NavigationTabs({ tabs }: NavigationTabsProps): ReactElement {
  return (
    <nav aria-label="navigation-tabs">
      <ul className="tabs">
        {tabs.map(({ label, pathname }) => (
          <li
            className={classnames('tab', {
              active: window.location.pathname.includes(pathname),
            })}
            key={label}
          >
            <Link to={pathname}>
              <div className="tab__heading" title={label}>
                {label}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
